 
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
//es-lint-
import _ from 'underscore';
import StringUtils from './string_utils';

// https://github.com/geetarista/underscore.inflections/blob/master/lib/underscore.inflections.js
export default (function() {
  const Inflector = class Inflector {
    static initClass() {
      // Common uncountable words
      this.prototype.defaultUncountables = [
        'equipment',
        'information',
        'rice',
        'money',
        'species',
        'series',
        'fish',
        'sheep',
        'jeans',
        'moose',
        'deer',
        'news',
        'music'
      ];

      // Plural rules
      this.prototype.defaultPluralRules = [
        [/$/, 's'],
        [/s$/i, 's'],
        [/^(ax|test)is$/i, '$1es'],
        [/(octop|vir)us$/i, '$1i'],
        [/(octop|vir)i$/i, '$1i'],
        [/(alias|status)$/i, '$1es'],
        [/(bu)s$/i, '$1ses'],
        [/(buffal|tomat)o$/i, '$1oes'],
        [/([ti])um$/i, '$1a'],
        [/([ti])a$/i, '$1a'],
        [/sis$/i, 'ses'],
        [/(?:([^f])fe|([lr])f)$/i, '$1$2ves'],
        [/(hive)$/i, '$1s'],
        [/([^aeiouy]|qu)y$/i, '$1ies'],
        [/(x|ch|ss|sh)$/i, '$1es'],
        [/(matr|vert|ind)(?:ix|ex)$/i, '$1ices'],
        [/(m|l)ouse$/i, '$1ice'],
        [/(m|l)ice$/i, '$1ice'],
        [/^(ox)$/i, '$1en'],
        [/^(oxen)$/i, '$1'],
        [/(quiz)$/i, '$1zes']
      ];

      // Singular rules
      this.prototype.defaultSingularRules = [
        [/s$/i, ''],
        [/(ss)$/i, '$1'],
        [/(n)ews$/i, '$1ews'],
        [/([ti])a$/i, '$1um'],
        [/((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)(sis|ses)$/i, '$1$2sis'],
        [/(^analy)(sis|ses)$/i, '$1sis'],
        [/([^f])ves$/i, '$1fe'],
        [/(hive)s$/i, '$1'],
        [/(tive)s$/i, '$1'],
        [/([lr])ves$/i, '$1f'],
        [/([^aeiouy]|qu)ies$/i, '$1y'],
        [/(s)eries$/i, '$1eries'],
        [/(m)ovies$/i, '$1ovie'],
        [/(x|ch|ss|sh)es$/i, '$1'],
        [/(m|l)ice$/i, '$1ouse'],
        [/(bus)(es)?$/i, '$1'],
        [/(o)es$/i, '$1'],
        [/(shoe)s$/i, '$1'],
        [/(cris|test)(is|es)$/i, '$1is'],
        [/^(a)x[ie]s$/i, '$1xis'],
        [/(octop|vir)(us|i)$/i, '$1us'],
        [/(alias|status)(es)?$/i, '$1'],
        [/^(ox)en/i, '$1'],
        [/(vert|ind)ices$/i, '$1ex'],
        [/(matr)ices$/i, '$1ix'],
        [/(quiz)zes$/i, '$1'],
        [/(database)s$/i, '$1']
      ];

      // Irregular rules
      this.prototype.defaultIrregularRules = [
        ['person', 'people'],
        ['man', 'men'],
        ['child', 'children'],
        ['sex', 'sexes'],
        ['move', 'moves'],
        ['cow', 'kine'],
        ['zombie', 'zombies']
      ];

      this.prototype.defaultHumanRules = [];
    }

    // Set up arrays and apply default rules
    constructor() {
      this.applyDefaultRules = this.applyDefaultRules.bind(this);
      this.applyDefaultUncountables = this.applyDefaultUncountables.bind(this);
      this.applyDefaultPlurals = this.applyDefaultPlurals.bind(this);
      this.acronym = this.acronym.bind(this);
      this.plural = this.plural.bind(this);
      this.singular = this.singular.bind(this);
      this.irregular = this.irregular.bind(this);
      this.uncountable = this.uncountable.bind(this);
      this.human = this.human.bind(this);
      this.clearInflections = this.clearInflections.bind(this);
      this.pluralize = this.pluralize.bind(this);
      this.singularize = this.singularize.bind(this);
      this.notranslate_pluralize = this.notranslate_pluralize.bind(this);
      this.camelize = this.camelize.bind(this);
      this.underscore = this.underscore.bind(this);
      this.humanize = this.humanize.bind(this);
      this.titleize = this.titleize.bind(this);
      this.apply_inflections = this.apply_inflections.bind(this);
      this.plurals = [];
      this.singulars = [];
      this.uncountables = [];
      this.humans = [];
      this.acronyms = {};

      this.applyDefaultRules();
    }

    // Apply all default rules
    applyDefaultRules() {
      this.applyDefaultUncountables();
      this.applyDefaultPlurals();
      this.applyDefaultSingulars();
      return this.applyDefaultIrregulars();
    }

    // Apply rules for list of uncountables
    applyDefaultUncountables() {
      return this.uncountable(this.defaultUncountables);
    }

    // Apply rules for list of default plurals
    applyDefaultPlurals() {
      return _.each(this.defaultPluralRules, rule => {
        const [regex, capture] = Array.from(rule);
        return this.plural(regex, capture);
      });
    }

    // Apply rules for list of default singulars
    applyDefaultSingulars() {
      return _.each(this.defaultSingularRules, rule => {
        const [regex, capture] = Array.from(rule);
        return this.singular(regex, capture);
      });
    }

    // Apply rules for list of default irregulars
    applyDefaultIrregulars() {
      return _.each(this.defaultIrregularRules, rule => {
        const [singular, plural] = Array.from(rule);
        return this.irregular(singular, plural);
      });
    }

    acronym(word) {
      this.acronyms[word.toLowerCase()] = word;
      return (this.acronym_matchers = _.values(this.acronyms).join('|'));
    }

    // Specifies a new pluralization rule and its replacement. The rule can either be a string or a regular expression.
    // The replacement should always be a string that may include references to the matched data from the rule.
    plural(rule, replacement) {
      if (typeof rule === 'string') {
        delete this.uncountables[_.indexOf(this.uncountables, rule)];
      }
      delete this.uncountables[_.indexOf(this.uncountables, replacement)];
      return this.plurals.unshift([rule, replacement]);
    }

    // Specifies a new singularization rule and its replacement. The rule can either be a string or a regular expression.
    // The replacement should always be a string that may include references to the matched data from the rule.
    singular(rule, replacement) {
      if (typeof rule === 'string') {
        delete this.uncountables[_.indexOf(this.uncountables, rule)];
      }
      delete this.uncountables[_.indexOf(this.uncountables, replacement)];
      return this.singulars.unshift([rule, replacement]);
    }

    // Specifies a new irregular that applies to both pluralization and singularization at the same time. This can only be used
    // for strings, not regular expressions. You simply pass the irregular in singular and plural form.
    //
    // Examples:
    //
    //     _.irregular('octopus', 'octopi')
    //     _.irregular('person', 'people')
    irregular(singular, plural) {
      delete this.uncountables[_.indexOf(this.uncountables, singular)];
      delete this.uncountables[_.indexOf(this.uncountables, plural)];
      if (singular.substring(0, 1).toUpperCase() === plural.substring(0, 1).toUpperCase()) {
        this.plural(
          new RegExp(`(${singular.substring(0, 1)})${singular.substring(1, plural.length)}$`, 'i'),
          `$1${plural.substring(1, plural.length)}`
        );
        this.plural(
          new RegExp(`(${plural.substring(0, 1)})${plural.substring(1, plural.length)}$`, 'i'),
          `$1${plural.substring(1, plural.length)}`
        );
        return this.singular(
          new RegExp(`(${plural.substring(0, 1)})${plural.substring(1, plural.length)}$`, 'i'),
          `$1${singular.substring(1, plural.length)}`
        );
      }
      this.plural(
        new RegExp(`${singular.substring(0, 1)}${singular.substring(1, plural.length)}$`, 'i'),
        plural.substring(0, 1) + plural.substring(1, plural.length)
      );
      this.plural(
        new RegExp(`${singular.substring(0, 1)}${singular.substring(1, plural.length)}$`, 'i'),
        plural.substring(0, 1) + plural.substring(1, plural.length)
      );
      this.plural(
        new RegExp(`${plural.substring(0, 1)}${plural.substring(1, plural.length)}$`, 'i'),
        plural.substring(0, 1) + plural.substring(1, plural.length)
      );
      this.plural(
        new RegExp(`${plural.substring(0, 1)}${plural.substring(1, plural.length)}$`, 'i'),
        plural.substring(0, 1) + plural.substring(1, plural.length)
      );
      this.singular(
        new RegExp(`${plural.substring(0, 1)}${plural.substring(1, plural.length)}$`, 'i'),
        singular.substring(0, 1) + singular.substring(1, plural.length)
      );
      return this.singular(
        new RegExp(`${plural.substring(0, 1)}${plural.substring(1, plural.length)}$`, 'i'),
        singular.substring(0, 1) + singular.substring(1, plural.length)
      );
    }

    // Add uncountable words that shouldn't be attempted inflected.
    //
    // Examples:
    //
    //     _.uncountable("money")
    //     _.uncountable("money", "information")
    //     _.uncountable(["money", "information", "rice"])
    uncountable(...words) {
      this.uncountables.push(words);
      return (this.uncountables = _.flatten(this.uncountables));
    }

    human(rule, replacement) {
      return this.humans.unshift([rule, replacement]);
    }

    // Clears the loaded inflections within a given scope (default is `'all'`).
    // Give the scope as a symbol of the inflection type, the options are: `'plurals'`,
    // `'singulars'`, `'uncountables'`, `'humans'`.
    //
    // Examples:
    //
    //     _.clearInflections('all')
    //     _.clearInflections('plurals')
    clearInflections(scope) {
      if (scope == null) {
        scope = 'all';
      }
      return (this[scope] = []);
    }

    // Pluralizes a word
    //
    // Examples:
    //
    //     _.pluralize('')
    pluralize(word, count, options) {
      if (options == null) {
        options = {};
      }
      options = _.extend({ plural: undefined, showNumber: true }, options);

      if (count !== undefined) {
        let result = '';
        if (options.showNumber === true) {
          result += `${count != null ? count : 0} `;
        }
        return (result +=
          count === 1 || __guardMethod__(count, 'toString', o => o.toString().match(/^1(\.0+)?$/))
            ? word
            : options.plural != null
            ? options.plural
            : this.pluralize(word));
      }
      return this.apply_inflections(word, this.plurals);
    }

    // Singularizes a word
    singularize(word) {
      return this.apply_inflections(word, this.singulars);
    }

    notranslate_pluralize(word, count) {
      if (count == null) {
        count = 0;
      }
      const result = `<var count pluralize='${count}'>${count}</var> `;
      const pword =
        count === 1 || __guardMethod__(count, 'toString', o => o.toString().match(/^1(\.0+)?$/))
          ? word
          : this.pluralize(word);
      return result + StringUtils.escapeHTML(pword);
    }

    camelize(term, uppercase_first_letter) {
      if (uppercase_first_letter == null) {
        uppercase_first_letter = true;
      }
      if (uppercase_first_letter) {
        term = term.replace(/^[a-z\d]*/, a => this.acronyms[a] || _.capitalize(a));
      } else {
        term = term.replace(new RegExp(`^(?:${this.acronym_matchers}(?=\\b|[A-Z_])|\\w)`), a =>
          a.toLowerCase()
        );
      }
      return (term = term.replace(/(?:_|(\/))([a-z\d]*)/gi, (match, $1, $2, idx, string) => {
        if (!$1) {
          $1 = '';
        }
        return `${$1}${this.acronyms[$2] || _.capitalize($2)}`;
      }));
    }

    underscore(camel_cased_word) {
      let word = camel_cased_word;
      word = word.replace(
        new RegExp(`(?:([A-Za-z\\d])|^)(${this.acronym_matchers})(?=\\b|[^a-z])`, 'g'),
        (match, $1, $2) => `${$1 || ''}${$1 ? '_' : ''}${$2.toLowerCase()}`
      );
      word = word.replace(/([A-Z\d]+)([A-Z][a-z])/g, '$1_$2');
      word = word.replace(/([a-z\d])([A-Z])/g, '$1_$2');
      word = word.replace('-', '_');
      return (word = word.toLowerCase());
    }

    humanize(lower_case_and_underscored_word) {
      let word = lower_case_and_underscored_word;
      for (const human of Array.from(this.humans)) {
        const rule = human[0];
        const replacement = human[1];
        if (
          (rule.test != null && rule.test(word)) ||
          (rule.indexOf != null && word.indexOf(rule) >= 0)
        ) {
          word = word.replace(rule, replacement);
          break;
        }
      }
      word = word.replace(/_id$/g, '');
      word = word.replace(/_/g, ' ');
      word = word.replace(/([a-z\d]*)/gi, match => this.acronyms[match] || match.toLowerCase());
      return (word = _.trim(word).replace(/^\w/g, match => match.toUpperCase()));
    }

    titleize(word) {
      return this.humanize(this.underscore(word)).replace(
        /([\s¿]+)([a-z])/g,
        (match, boundary, letter, idx, string) => match.replace(letter, letter.toUpperCase())
      );
    }

    // Apple rules to a given word. If the last word fo the string is uncountable,
    // just return it. Otherwise, make the replacement and return that.
    apply_inflections(word, rules) {
      if (!word) {
        return word;
      }
      let result = word;
      const match = result.toLowerCase().match(/\b\w+$/);
      if (match && _.indexOf(this.uncountables, match[0]) !== -1) {
        return result;
      }
      for (const rule of Array.from(rules)) {
        const [regex, capture] = Array.from(rule);
        if (result.match(regex)) {
          result = result.replace(regex, capture);
          break;
        }
      }
      return result;
    }
  };
  Inflector.initClass();
  return Inflector;
})();

function __guardMethod__(obj, methodName, transform) {
  if (typeof obj !== 'undefined' && obj !== null && typeof obj[methodName] === 'function') {
    return transform(obj, methodName);
  }
  return undefined;
}
